import styled from "styled-components";  
import { IStyleProps } from "../interfaces";

export const EditorWrapper = styled.div<IStyleProps>`
    /* Common CSS */
    .editor-wrapper {
        border: 1px solid #aaa;
        min-height: 200px;
        border-radius: 4px;
    }
    .custom-editor.rdw-editor-main {
        min-height: 200px;
        padding: 0px 20px;
        max-height: 200px;
        &::-webkit-scrollbar {
            width: 0.3em;
            height: 0.4em;
            background-color: rgba(21, 40, 55, 0.1);
        }
        &::-webkit-scrollbar-thumb {
            border-radius: 4px;
            outline: 1px solid #ddd;
            background-color: rgba(21, 40, 55, 0.3);
        }
    }

    /* Custom CSS */
    .product-detail-editor.editor-wrapper {
        max-width: 620px;
        p,
        .public-DraftStyleDefault-block {
            margin-bottom: 0px;
        }
    }
    .rdw-right-aligned-block,
    .rdw-left-aligned-block,
    .rdw-center-aligned-block,
    .rdw-justify-aligned-block {
        > div {
            word-break: break-word;
        }
    }
`;
